/**
 * SchemaToggle
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Radio } from 'semantic-ui-react';

// Actions
import {
    enableSchema,
    disableSchema
} from '../../../../../../../../../../services/schemas/actions';

// Selectors
import { makeSelectSchemaValue } from '../../../../../../../../../../services/schemas/selectors';

interface Props {
    schemaId?: number | string;
    isEnabled?: boolean;
    enableSchema: Function;
    disableSchema: Function;
}

export class SchemaToggle extends React.PureComponent<Props> {
    render() {
        const { schemaId, isEnabled } = this.props;
        if (!schemaId) return null;
        return (
            <Radio
                toggle
                checked={isEnabled}
                onChange={() => {
                    if (isEnabled) {
                        this.props.disableSchema(schemaId);
                    } else {
                        this.props.enableSchema(schemaId);
                    }
                }}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector({
    isEnabled: makeSelectSchemaValue('isEnabled')
});

export default connect(
    mapStateToProps,
    { enableSchema, disableSchema }
)(SchemaToggle);
